import React, { Component, Fragment } from 'react'
import {
  Row,
  Col,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Collapse,
  Alert,Nav,NavItem
} from 'reactstrap';
import {Typeahead} from 'react-bootstrap-typeahead'

import { orderAmount} from '../share/order_helper'
import { toDate} from '../share/date_helper'

import DatePicker from './DatePicker'

class OrderForm extends Component {
  constructor(props) {
    super(props)
    this.today = new Date()
    this.state = {
      error: null,
      showProgressPanel: false,
      isSubmitting: false,
      payload: {
        client: '',
        address: '',
        tax: 19,
        date: this.today,
        gross: true,
        shippingCosts: 0,
        items: [],
        payedAt: this.today,
        cancelled: false,
        cancellationCause: '',
        shippedAt: '',
        orderSource: '',
        discount: 0,
        paymentMethod: 'paypal'
      }
    };
  }

  static getDerivedStateFromProps(props, state) {
    const payload = props.order || {items:[]}
    if(payload && payload.id && !state.payload.id) {
      const newPayload = {...payload,
        items: (payload.items || []).slice(),
        date: toDate(payload.date) || '',
        payedAt: toDate(payload.payedAt) || '',
        shippedAt: toDate(payload.shippedAt) || ''
      }
      return {...state, payload: Object.assign({},state.payload,newPayload), showProgressPanel: !!payload.id}
    }
    return null
  }

  addItem = () => {
    const items = this.state.payload.items.slice()
    items.push({product: '', count: 1, price: 0})
    const newPayload = {...this.state.payload, items}
    this.setState({payload: newPayload})
  }

  removeItem = (index,e) => {
    if(e) e.preventDefault()
    const items = this.state.payload.items.slice()
    items.splice(index,1)
    const newPayload = {...this.state.payload, items}
    this.setState({payload: newPayload})
  }

  handleChange = (e) => {
    let value = e.target.type === 'checkbox' ? e.target.checked : e.target.value
    if(value === 'true') value = true
    if(value === 'false') value = false
    const newPayload = {...this.state.payload, [e.target.name]: value}

    this.setState({payload: newPayload})
  }

  updateValues = (values) => {
    const newPayload = {...this.state.payload}
    values.forEach((data) => {newPayload[data.name] = data.value})
    this.setState({payload: newPayload})
  }

  handleItemChange = (index,e) => {
    const items = this.state.payload.items.slice()
    const item = {...items[index], [e.target.name]: e.target.value}
    items[index] = item
    const newPayload = {...this.state.payload, items}
    this.setState({payload: newPayload})
  }

  updateItemValues = (index,values) => {
    const items = this.state.payload.items.slice()
    const item = {...items[index]}
    values.forEach((data) => {item[data.name] = data.value})
    items[index] = item
    const newPayload = {...this.state.payload, items}
    this.setState({payload: newPayload})
  }

  handleSubmit = (e) => {
    e.preventDefault()
    this.setState({error: null, isSubmitting: true})
    const values = {...this.state.payload}
    values.date = values.date || null
    values.payedAt = values.payedAt || null
    values.shippedAt = values.shippedAt || null
    values.shippingCosts = parseFloat(values.shippingCosts)
    values.tax = parseFloat(values.tax)
    values.items = values.items.map(item => {
      item.price = parseFloat(item.price)
      return item
    })

    this.props.submit(values)
      .then(() => this.setState({isSubmitting: false}))
      .catch(error => this.setState({isSubmitting: false, error}))
  }

  isValid = (name, value) => {
    switch(name) {
      case 'item':
        return !!value.product && value.product.length>0
      case 'client':
        return !!this.state.payload.client &&
               this.state.payload.client.length>0
      case 'address':
        return !!this.state.payload.address &&
               this.state.payload.address.length>0
      case 'tax':
        return !!this.state.payload.tax || this.state.payload.tax===0
      case 'items':
        return !!this.state.payload.items && this.state.payload.items.length>0 &&
               this.state.payload.items.reduce((valid,item) =>
                 valid && this.isValid('item',item), true
               )
      case 'date': return !!this.state.payload.date
      default: return false
    }
  }

  validate = () =>
    ['client','address','tax','items','date'].reduce((valid,cur) =>
      valid && this.isValid(cur)
    )

  renderBillInfos = () => {
    const {payload} = this.state

    const orderSources = this.props.orders
                         ? this.props.orders.items.map(order => order.orderSource)
                           .filter((elem, pos, arr) =>
                             elem && typeof elem === 'string' &&
                             arr.indexOf(elem) === pos
                           )
                         : []

    return(
      <Fragment>
        <Row>
          <Col sm="6">
            <FormGroup>
              <Label for="client">Rechnungsempfänger</Label>
              <Typeahead
                onInputChange={(value) => {
                  this.updateValues([{name: 'client', value}])
                }}
                isValid={this.isValid('client')}
                isInvalid={!this.isValid('client')}
                onChange={(selected) => {
                  const {name,address} = selected[0] || {}
                  if(name || address) {
                    this.updateValues([{name: 'client', value: name}, {name: 'address', value: address}])
                  }
                }}
                options={this.props.clients.items}
                selected={[{name: payload.client || ''}]}
                labelKey={option => `${option.name}`}
              />
            </FormGroup>
          </Col>
          <Col sm="6">
            <FormGroup>
              <Label for="address">Rechnungsadresse</Label>
              <Input
                valid={this.isValid('address')}
                invalid={!this.isValid('address')}
                type="text"
                name="address"
                id="address"
                value={payload.address}
                placeholder="Musterstr. 34, 10179 Berlin"
                onChange={this.handleChange} />
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col sm="2">
            <FormGroup>
              <Label for="date">Bestelldatum</Label>
              <DatePicker
                valid={this.isValid('date')}
                invalid={!this.isValid('date')}
                value={payload.date}
                onChange={(e) => {
                  const values = [{name: 'date', value: e.target.value}]
                  // const fifeDaysAgo = new Date(this.today)
                  // fifeDaysAgo.setDate(this.today.getDate()-5)

                  if(!payload.payedAt ||
                     e.target.value>payload.payedAt ||
                     (payload.payedAt===this.today && e.target.value!==this.today)) {
                    values.push({name: 'payedAt', value: e.target.value})
                  }
                  this.updateValues(values)
                }}
                name="date"/>
            </FormGroup>
          </Col>

          <Col sm="4">
            <FormGroup>
              <Label for="orderSource">Bestellt über</Label>

              <Typeahead
                onInputChange={value =>
                  this.updateValues([{name: 'orderSource', value}])
                }
                onChange={selected =>
                  selected[0] && this.updateValues([{name: 'orderSource', value: selected[0]}])
                }
                options={orderSources}
                selected={[payload.orderSource || '']}
                labelKey={option => `${option}`}
              />
            </FormGroup>
          </Col>

          <Col sm="2">
            <FormGroup>
              <Label for="tax">Umsatzsteuer</Label>
              <div className="input-group mb-2">
                <Input
                  type="number"
                  name="tax"
                  id="tax"
                  value={payload.tax}
                  onChange={this.handleChange}/>

                <div className="input-group-append">
                  <span className="input-group-text">%</span>
                </div>
              </div>
            </FormGroup>
          </Col>

          <Col sm="2">
            <FormGroup>
              <Label for="shippingCosts">Versandkosten</Label>
              <div className="input-group mb-2">
                <Input
                  type="number"
                  name="shippingCosts"
                  value={payload.shippingCosts}
                  onChange={this.handleChange}/>
                <div className="input-group-append">
                  <span className="input-group-text">€</span>
                </div>
              </div>
            </FormGroup>
          </Col>

          <Col sm="2">
            <FormGroup>
              <Label for="discount">Rabatt</Label>
              <div className="input-group mb-2">
                <Input
                  type="number"
                  name="discount"
                  value={payload.discount}
                  onChange={this.handleChange}/>
                <div className="input-group-append">
                  <span className="input-group-text">€</span>
                </div>
              </div>
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col sm="6">
            <FormGroup check inline>
              <Label check>Angaben sind </Label>
            </FormGroup>
            <FormGroup check inline>
              <Label check>
                <Input
                  type="radio"
                  name="gross"
                  checked={!payload.gross}
                  onChange={this.handleChange}
                  value='false'/> Netto
              </Label>
            </FormGroup>
            <FormGroup check inline>
              <Label check>
                 <Input
                   type="radio"
                   name="gross"
                   checked={payload.gross}
                   onChange={this.handleChange}
                   value='true'/> Brutto
              </Label>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <hr/>
        </Row>
      </Fragment>
    )
  }

  renderProgressInfos = () => {
    const {payload} = this.state
    return (
      <Fragment>
        <Nav pills className="justify-content-end">
          <NavItem>
            <Button
              color="secondary"
              size="sm"
              className="pull-right"
              onClick={() => this.setState({showProgressPanel: !this.state.showProgressPanel})}
              style={{ marginBottom: '1rem' }}>
              Abschliessen {' '}
              <i className={`fas fa-angle-double-${this.state.showProgressPanel ? 'up' : 'down'}`}/>
            </Button>
          </NavItem>
        </Nav>

        <Collapse isOpen={this.state.showProgressPanel}>
          <Alert color="secondary">
            <Row>
              <Col sm="3">
                <FormGroup>
                  <Label for="payedAt">Bezahlt am</Label>
                  <DatePicker
                    value={payload.payedAt}
                    onChange={this.handleChange}
                    name="payedAt"/>
                </FormGroup>
                <FormGroup>
                  <Label for="paymentMethod">Bezahlt via</Label>
                  <Input
                    type="select"
                    value={payload.paymentMethod}
                    name="paymentMethod"
                    onChange={this.handleChange}>
                    <option value="onAccount">Auf Rechnung</option>
                    <option value="paypal">PayPal</option>
                    <option value="bankTransfer">Sofortüberweisung</option>
                  </Input>
                </FormGroup>
              </Col>

              <Col sm="3">
                <FormGroup>
                  <Label for="shippedAt">Versendet am</Label>
                    <DatePicker
                      value={payload.shippedAt}
                      onChange={this.handleChange}
                      name="shippedAt"/>
                </FormGroup>
              </Col>

              <Col sm="6">
                <FormGroup>
                  <Label for="cancelled">Stornierung</Label>
                  <div className="input-group mb-3">
                    <div className="input-group-prepend">
                      <div className="input-group-text">
                        <input
                          type="checkbox"
                          name="cancelled"
                          checked={payload.cancelled}
                          onChange={this.handleChange}/>
                      </div>
                    </div>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Grund für die Stornierung"
                      name="cancellationCause"
                      disabled={!payload.cancelled}
                      value={payload.cancellationCause || ''}
                      onChange={this.handleChange}/>
                  </div>
                </FormGroup>
              </Col>
            </Row>

          </Alert>
        </Collapse>
      </Fragment>
    )
  }

  renderItems = () => {
    const {payload} = this.state

    return(
      <Fragment>
        <Row>
          <Col sm="6">
            <h5>Leistungen</h5>
          </Col>
          <Col sm="6">
            <Nav pills className="justify-content-end">
              <NavItem>
                <Button
                  color='secondary'
                  size="sm"
                  onClick={(e) => {e.preventDefault(); this.addItem()}}>
                  <i className="fas fa-plus"/>
                </Button>
              </NavItem>
            </Nav>
          </Col>
        </Row>

        {payload.items.length > 0 &&
          <Fragment>
            <div className='form-row'>
              <div className='col-sm-6'>Beschreibung</div>
              <div className='col-sm-2'>Anzahl</div>
              <div className='col-sm-3'>Preis</div>
              <div className='col-sm-1'/>
            </div>
            {payload.items && payload.items.map((item,index) =>
              <div className='form-row' key={index}>
                <div className='col-sm-6'>
                  <Typeahead
                    onInputChange={(value) => {
                      this.updateItemValues(index,[{name: 'product', value}])
                    }}

                    isValid={this.isValid('item',item)}
                    isInvalid={!this.isValid('item',item)}

                    onChange={(selected) => {
                      const {name,price} = selected[0] || {}
                      if(name || price) {
                        this.updateItemValues(index,[
                          {name: 'product', value: name},
                          {name: 'price', value: price}
                        ])
                      }
                    }}
                    options={this.props.products.items}
                    selected={[{name: payload.items[index].product || ''}]}
                    labelKey={option => `${option.name}`}
                  />
                </div>
                <div className='col-sm-2'>
                  <Input
                    type="number"
                    name="count"
                    id="count"
                    onChange={(e) => this.handleItemChange(index,e)}
                    value={payload.items[index].count}/>
                </div>
                <div className='col-sm-3'>
                  <div className="input-group mb-3">
                    <Input
                      type="number"
                      name="price"
                      id="price"
                      onChange={(e) => this.handleItemChange(index,e)}
                      value={payload.items[index].price}/>
                    <div className="input-group-append">
                      <span className="input-group-text">€</span>
                    </div>
                  </div>
                </div>
                <div className='col-sm-1'>
                  <Nav pills className="justify-content-end">
                    <NavItem>
                      <Button
                        color='secondary'
                        size="sm"
                        onClick={(e) => {this.removeItem(index,e)}}>
                        <i className="fas fa-trash-alt"/>
                      </Button>
                    </NavItem>
                  </Nav>

                </div>
              </div>
            )}
          </Fragment>
        }
      </Fragment>
    )
  }

  renderAmmount = () => {
    const {payload} = this.state
    const amount = orderAmount(payload,'de-DE')

    return(
      <React.Fragment>
        {payload.items.length>0 &&
          <div className='form-row'>
            <div className='col-sm-6'/>
            <div className='col-sm-5'>
              <table width='100%'>
                <tbody>
                  <tr>
                    <td>Summe:</td>
                    <td className="text-right">{amount.nettHuman}€</td>
                  </tr>
                  {amount.shippingCosts>0 &&
                    <tr>
                      <td>Versand:</td>
                      <td className="text-right">{amount.shippingCostsHuman}€</td>
                    </tr>
                  }
                  {amount.discount>0 &&
                    <tr>
                      <td>Rabatt:</td>
                      <td className="text-right">{amount.discountHuman}€</td>
                    </tr>
                  }
                  <tr>
                    <td>Total Netto:</td>
                    <td className="text-right">{amount.totalNettHuman}€</td>
                  </tr>
                  <tr>
                    <td>UmStg.:</td>
                    <td className="text-right">{amount.taxHuman}€</td>
                  </tr>
                  <tr>
                    <td>zu zahlender Betrag:</td>
                    <td className="text-right">{amount.totalGrossHuman}€</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        }
      </React.Fragment>
    )
  }

  render() {
    const Body = this.props.bodyComponent
    const Buttons = this.props.buttonsComponent
    const valid = this.validate()

    return(
      <Form onSubmit={this.handleSubmit}>
        <Body>
          {this.state.error &&
            <p className="text-danger">{this.state.error.message}</p>
          }

          {this.renderProgressInfos()}
          {this.renderBillInfos()}
          {this.renderItems()}
          {this.renderAmmount()}
        </Body>
        <Buttons>
          <Button
            color="primary"
            disabled={!valid || this.state.isSubmitting}
            onClick={this.handleSubmit}>
            {this.state.isSubmitting ? 'Bitte Warten...' : 'Speichern'}
          </Button>{' '}
        </Buttons>
      </Form>
    )
  }
}

OrderForm.defaultProps = {
  bodyComponent: React.Fragment,
  buttonsComponent: React.Fragment
};

export default OrderForm



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/components/OrderForm.js